import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { AuthRoutingModule } from '@pg-app/auth/auth-routing.module';
import { AnotherWayLoginComponent } from '@pg-app/auth/components/another-way-login/another-way-login.component';
import { LoginErrorPhoneComponent } from '@pg-app/auth/components/login-error-phone/login-error-phonecomponent';
import { LoginLayoutComponent } from '@pg-app/auth/components/login-layout/login-layout.component';
import { ReturnLoginLayoutComponent } from '@pg-app/auth/components/return-login-layout/return-login-layout.component';
import { ChangePasswordComponent } from '@pg-app/auth/containers/login/change-password/change-password.component';
import { ChangePinComponent } from '@pg-app/auth/containers/login/change-pin/change-pin.component';
import { LoginStep2Component } from '@pg-app/auth/containers/login/login-step2/login-step2.component';
import { LoginStep3Component } from '@pg-app/auth/containers/login/login-step3/login-step3.component';
import { LoginComponent } from '@pg-app/auth/containers/login/login/login.component';
import { ReactivateAccountComponent } from '@pg-app/auth/containers/login/reactivate-account/reactivate-account.component';
import { ReactivateSendCodeComponent } from '@pg-app/auth/containers/login/reactivate-send-code/reactivate-send-code.component';
import { ResetPasswordSendCodeComponent } from '@pg-app/auth/containers/login/reset-password-send-code/reset-password-send-code.component';
import { ResetPasswordComponent } from '@pg-app/auth/containers/login/reset-password/reset-password.component';
import { ResetPinSendCodeComponent } from '@pg-app/auth/containers/login/reset-pin-send-code/reset-pin-send-code.component';
import { ResetPinComponent } from '@pg-app/auth/containers/login/reset-pin/reset-pin.component';
import { AddPhoneNumberComponent } from '@pg-app/auth/containers/register/add-phone-number/add-phone-number.component';
import { VerifyEmailComponent } from '@pg-app/auth/containers/register/verify-email/verify-email.component';
import { VerifyPasscodeComponent } from '@pg-app/auth/containers/register/verify-passcode/verify-passcode.component';
import { RegisterComponent } from '@pg-app/auth/containers/register/register/register.component';
import { AlternativeReceiveCodeComponent } from '@pg-app/auth/components/alternative-receive-code/alternative-receive-code.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { RegisterCorporateComponent } from '@pg-app/auth/containers/register/register-corporate/register-corporate.component';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { PinTwillioAuthyModule } from '@pg-app/common/pin-twillio-authy/pin-twillio-authy.module';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { ProfileSwitchingComponent } from './containers/login/profile-switching/profile-switching.component';
import { MatSelectHybridModule } from "../../../libs/mat-select-hybrid/mat-select-hybrid.module";
import { NgTableModule } from '@nttp/table/ng-table.module';

@NgModule({
    declarations: [
        LoginComponent,
        LoginStep2Component,
        LoginStep3Component,
        LoginLayoutComponent,
        ReactivateAccountComponent,
        ReturnLoginLayoutComponent,
        ResetPasswordComponent,
        ResetPinComponent,
        AnotherWayLoginComponent,
        ReactivateSendCodeComponent,
        ResetPasswordSendCodeComponent,
        ResetPinSendCodeComponent,
        ResetPasswordSendCodeComponent,
        ChangePasswordComponent,
        ChangePinComponent,
        LoginErrorPhoneComponent,
        AddPhoneNumberComponent,
        VerifyEmailComponent,
        VerifyPasscodeComponent,
        AlternativeReceiveCodeComponent,
        RegisterComponent,
        RegisterCorporateComponent,
        ProfileSwitchingComponent,
    ],
    imports: [
        CommonModule,
        CoreUiModule,
        CoreMaterialModule,
        ReactiveFormsModule,
        AuthRoutingModule,
        NgxMatSelectSearchModule,
        CommonDialogModule,
        PipeModule,
        PinTwillioAuthyModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        MatSelectHybridModule,
        NgTableModule,
    ]
})
export class AuthModule { }
